module.exports = __webpack_public_path__ + "img/icon_vip_1@2x.94493a25.png";